import { IGetRegionMetaResponse } from '../repositories/geo-temp-layer/v1/get-region-meta';
import { TRegionMeta } from '../types/regionMeta';

export function prepareRegionMeta(response: IGetRegionMetaResponse): TRegionMeta {
  const { location } = response;

  if (!location) {
    return null;
  }

  return {
    id: location.id as number,
    displayName: location.displayName || '',
    baseHost: location.baseHost,
    mainTownId: location.mainTownId,
  };
}
